module.exports = __webpack_public_path__ + "img/15_7.4bd09643.png";